import axios from 'axios'

export default {
  getAllRecords ( params, callback ) {
    axios.get('/cost-matrix', { params })
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(() => {});
  },
  getRecord ( recordId, callback, fallback ) {
    axios.get('/cost-matrix/' + recordId)
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        fallback(error);
      });
  },
  create ( data, callback, fallback ) {
    axios.post( '/cost-matrix', data )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        fallback(error);
      });
  },
  save ( recordId, data, callback, fallback ) {
    axios.post( '/cost-matrix/' + recordId, data )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
  delete ( recordId, callback, fallback ) {
    axios.delete( '/cost-matrix/' + recordId )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
  deleteMany ( reocrdIds, callback, fallback ) {
    axios.post( '/cost-matrix/delete', { ids: reocrdIds })
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  }
}
